import type { Cart } from '@grafikr/shopify-typescript/type/endpoints/Cart';
import { ComponentType } from '@grafikr/components';
import formatMoney from 'utils/format-money';

const Component: ComponentType = (node, { emitter }) => {
  const cartCount = document.querySelectorAll<HTMLSpanElement>('[data-cart-count]');
  const cartIconEmpty = document.querySelectorAll<HTMLSpanElement>('[data-cart-icon-empty]');
  const cartIconFilled = document.querySelectorAll<HTMLSpanElement>('[data-cart-icon-filled]');

  emitter.on('cart:updated', (cart: Cart) => {
    const calcShippingRemaining = () =>
      formatMoney(
        theme.freeShippingThreshold - cart.total_price,
        theme.moneyFormatWithCurrency,
      ).toString();

    if (cartCount) {
      cartCount.forEach((count) => {
        count.hidden = cart.item_count === 0;

        if (count.hasAttribute('data-wrap')) {
          count.textContent = `(${cart.item_count})`;
        } else {
          count.textContent = cart.item_count.toString();
        }
      });
    }

    cartIconEmpty.forEach((icon) => {
      icon.hidden = cart.item_count !== 0;
    });

    cartIconFilled.forEach((icon) => {
      icon.hidden = cart.item_count === 0;
    });

    const freeShippingCounter = document.querySelector('[data-free-shipping-counter]');
    if (freeShippingCounter) {
      if (cart.total_price > theme.freeShippingThreshold) {
        freeShippingCounter.textContent = theme.strings.cart.freeShippingAchieved;
      } else if (theme.freeShippingThreshold > theme.freeShippingThreshold - cart.total_price) {
        freeShippingCounter.textContent = theme.strings.cart.buyXForFreeShipping.replace(
          '%%AMOUNT%%',
          calcShippingRemaining(),
        );
      } else {
        freeShippingCounter.textContent = theme.strings.cart.freeShippingAt.replace(
          '%%AMOUNT%%',
          formatMoney(theme.freeShippingThreshold, theme.moneyFormatWithCurrency).toString(),
        );
      }
    }
  });
};

export default Component;
